import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrossCircleFillMini = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9999 21.5999C17.3018 21.5999 21.5999 17.3018 21.5999 11.9999C21.5999 6.69797 17.3018 2.3999 11.9999 2.3999C6.69797 2.3999 2.3999 6.69797 2.3999 11.9999C2.3999 17.3018 6.69797 21.5999 11.9999 21.5999ZM9.9363 8.66351C9.58483 8.31203 9.01498 8.31203 8.66351 8.66351C8.31203 9.01498 8.31203 9.58483 8.66351 9.9363L10.7271 11.9999L8.66351 14.0635C8.31203 14.415 8.31203 14.9848 8.66351 15.3363C9.01498 15.6878 9.58483 15.6878 9.9363 15.3363L11.9999 13.2727L14.0635 15.3363C14.415 15.6878 14.9848 15.6878 15.3363 15.3363C15.6878 14.9848 15.6878 14.415 15.3363 14.0635L13.2727 11.9999L15.3363 9.9363C15.6878 9.58483 15.6878 9.01498 15.3363 8.66351C14.9848 8.31203 14.415 8.31203 14.0635 8.66351L11.9999 10.7271L9.9363 8.66351Z",
		fill: "currentcolor"
	})]
});
export default SvgCrossCircleFillMini;
